import React from "react";
import styles from "./Team.module.css";
import { TeamMember } from "../../types";

interface TeamProps {
  teammates: TeamMember[];
}

const Team: React.FC<TeamProps> = ({ teammates }) => {
  return (
    <section id="teams" className={styles.teams}>
      <div className="container">
        <div className={styles.sectionTitle}>
          <h2 className={styles.sectionTitleH2}>Meet The Team</h2>
          <p className={styles.sectionTitleP}>
            A young, dynamic team delivering superior quality supply and service
            excellence through integrity, safety and reliability.
          </p>
        </div>

        <div className={styles.teamsGrid}>
          {teammates.map((teammate) => (
            <div key={teammate.id} className={styles.teamCard}>
              <div className={styles.teamImageContainer}>
                <img
                  src={teammate.image}
                  alt={teammate.fullName}
                  className={styles.teamImage}
                />
                <div
                  className={`${styles.teamOverlay} ${styles.teamOverlayActive}`}
                >
                  <h3>{teammate.fullName}</h3>
                  <p>{teammate.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
